import { MouseEventHandler } from "react";
import uploadIcon from "src/assets/icons/icon-upload.svg";
import "./UploadImageContainer.scss";
import { Typography } from "src/latest/src/components";

interface Props {
    onUploadProfileClick?: MouseEventHandler<HTMLElement>;
}

export const UploadImageContainer = ({ onUploadProfileClick }: Props) => {
    return (
        <div className="upload-image-container" onClick={onUploadProfileClick}>
            <img
                src={uploadIcon}
                alt="upload-icon"
                className="photo-widget__upload upload-picture-img"
            />
            <Typography
                color="color-28"
                variant="size-16" 
                weight="semi-bold" 
                className="upload-picture-text"
            >
                Upload Picture
            </Typography>
        </div>
    );
};
